__turbopack_context__.v({
  "childAgeFields": "ChangeTravellersModal-module__gdwxcG__childAgeFields",
  "childAgeSelectField": "ChangeTravellersModal-module__gdwxcG__childAgeSelectField",
  "confirmButtonShell": "ChangeTravellersModal-module__gdwxcG__confirmButtonShell",
  "controlButton": "ChangeTravellersModal-module__gdwxcG__controlButton",
  "controls": "ChangeTravellersModal-module__gdwxcG__controls",
  "counterDetail": "ChangeTravellersModal-module__gdwxcG__counterDetail",
  "counterLabel": "ChangeTravellersModal-module__gdwxcG__counterLabel",
  "counterRow": "ChangeTravellersModal-module__gdwxcG__counterRow",
  "counterRowNoBorder": "ChangeTravellersModal-module__gdwxcG__counterRowNoBorder",
  "counterText": "ChangeTravellersModal-module__gdwxcG__counterText",
  "divider": "ChangeTravellersModal-module__gdwxcG__divider",
  "modalRoot": "ChangeTravellersModal-module__gdwxcG__modalRoot",
  "popoverCloseLink": "ChangeTravellersModal-module__gdwxcG__popoverCloseLink",
  "popoverContent": "ChangeTravellersModal-module__gdwxcG__popoverContent",
  "section": "ChangeTravellersModal-module__gdwxcG__section",
  "sectionHeading": "ChangeTravellersModal-module__gdwxcG__sectionHeading",
  "value": "ChangeTravellersModal-module__gdwxcG__value",
});
